
export default class Payment {
  wireReference?: string;
  amount?: number;
  errorReason?: string;
  paymentDate?: string;
  status?: string;

  constructor(entity: Payment) {
    this.wireReference = entity.wireReference || undefined;
    this.amount = entity.amount || undefined;
    this.errorReason = entity.errorReason || undefined;
    this.paymentDate = entity.paymentDate || undefined;
    this.status = entity.status || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/entities/Payment.tsx